// extracted by mini-css-extract-plugin
export default {"container":"betKalkulatoriLayout_container__auSB8","sidebar":"betKalkulatoriLayout_sidebar__ern9d","content":"betKalkulatoriLayout_content__ZZll5"};